import { Provider } from '@angular/core';
import { PaginatedStateLoadingMode } from '@shared/ui';
import {
  algorithmStoreProviders,
  algorithmDetailStoreProviders,
  pipelineStepDetailStoreProviders,
} from '../../../providers/store.providers';
import { AlgorithmSwitcherState } from '../../../state/algorithm-switcher.state';
import { SwitchAlgorithmFacade } from './switch-algorithm.facade';

export const switchAlgorithmProviders: Provider[] = [
  ...algorithmStoreProviders(PaginatedStateLoadingMode.CONTINUOUS),
  ...algorithmDetailStoreProviders,
  ...pipelineStepDetailStoreProviders,
  AlgorithmSwitcherState,
  SwitchAlgorithmFacade,
];
